

export default {
  name: 'CategoryInput',

  componentName: 'CategoryInput',

  props: {
    config: {
      type: Object,
      required: true
    },
    formValue: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {};
  },

  methods: {
    innerClass: function innerClass(item) {
      return {
        'node-content-notmatch': item.searchType === 'notmatch'
      };
    }
  }
};